import React, {useState} from 'react';
import Carousel from 'react-bootstrap/Carousel';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classnames from 'classnames'

/**
 * Componente GenericCarousel
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param children
 * @param className
 * @param style
 * @param indicators
 * @param showIndicators
 * @returns {JSX.Element}
 * @constructor
 */
const GenericCarousel = ({children, className = '', style, showIndicators = true}) => {

    const [index, setIndex] = useState(0);

    /**
     *
     * @param selectedIndex
     * @param e
     */
    const handleSelect = (selectedIndex, e) => {
        if (selectedIndex === index)
            return;

        setIndex(selectedIndex)
    }

    return (
        <>
            <Carousel
                style={style}
                activeIndex={index}
                className={`genericCarousel ${className}`}
                onSelect={handleSelect}
                prevIcon={<FontAwesomeIcon icon="chevron-left" className="preto"/>}
                nextIcon={<FontAwesomeIcon icon="chevron-right" className="preto"/>}
                indicators={false}
            >
                {
                    children && children.map((item, i) => (
                        <Carousel.Item key={i}>
                            {item}
                        </Carousel.Item>
                    ))
                }
            </Carousel>
            {/* custom indicators */}
            {
                showIndicators && (
                    <div className={'customIndicatorsContainer mt-2'}>
                        {
                            children && children.map((item, i) => {
                                const isActiveIndicator = (i === index);
                                return (
                                    <div key={i} className={classnames('mr-2 s20 rad10 p-1 d-inline-block', {
                                        'click': !isActiveIndicator,
                                        'hover': !isActiveIndicator,
                                        'hteen3': !isActiveIndicator,
                                        'teen3': !isActiveIndicator,
                                        'teen1': isActiveIndicator
                                    })} onClick={e => handleSelect(i, e)}>
                                        <FontAwesomeIcon icon={["far", isActiveIndicator ? 'dot-circle' : 'circle']}/>
                                    </div>
                                )
                            })
                        }
                    </div>
                ) || <div/>
            }
            {/* custom indicators */}
        </>
    );
}


export default GenericCarousel;
